import { Component, Input } from '@angular/core';
import { RegionSelectorService } from '~shared/modules/region-selector/services';
import { DEFAULT_REGION_SPAIN } from '~shared/modules/region-selector/constants/region-names.constant';
import { Region, RegionList } from '~shared/modules/region-selector/models/region-list.model';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { GtmDatalayerService } from '~shared/services/gtm-datalayer.service';
import { GaTrackingEventAction, GaTrackingEventName, GATrackingEventType } from '~shared/modules/ga-tracking/constants';

@Component({
  selector: 'app-region-selector',
  templateUrl: './region-selector.component.html',
  styleUrls: ['./region-selector.component.scss'],
})
export class RegionSelectorComponent {
  regionsList: Region[];
  isOpen = false;
  selectedRegion: string;
  @Input() mobileSidenavMenu: boolean;
  @Input() isNavigationuBarEnabledV2: boolean;
  userRegionCookie: string;
  userRegionCookieObj;
  private destroySubject$ = new Subject();
  constructor(
    private readonly regionSelectorService: RegionSelectorService,
    private gtmDatalayerService: GtmDatalayerService
  ) {}

  ngOnInit() {
    this.userRegionCookie = this.regionSelectorService.getUserRegion();
    this.regionSelectorService
      .fetchRegions()
      .pipe(takeUntil(this.destroySubject$))
      .subscribe((regions: RegionList): void => {
        const regionsListData: Region[] = regions.items;
        this.regionsList = this.rearrangeRegionsList(regionsListData);
        const defaultRegion = this.regionsList.find((region) => region.id === DEFAULT_REGION_SPAIN);
        if (this.userRegionCookie) {
          this.userRegionCookieObj = this.regionsList.find((region) => region.id === this.userRegionCookie);
          this.regionSelectorService.notifyUserRegion(this.userRegionCookieObj?.id);
        } else {
          this.regionSelectorService.setUserRegion(defaultRegion.id);
          this.regionSelectorService.notifyUserRegion(defaultRegion?.id);
        }
        this.selectedRegion = this.userRegionCookieObj?.name || defaultRegion?.name;
      });
  }

  ngOnDestroy() {
    this.destroySubject$.next();
    this.destroySubject$.complete();
  }

  setRegionSelected(selectedRegion: Region, event: Event) {
    this.selectedRegion = selectedRegion.name;
    this.regionSelectorService.setUserRegion(selectedRegion.id);
    this.isOpen = false;
    this.gtmDatalayerService.gtagEvent({
      event: GATrackingEventType.SE_LOCATION_TOGGLER,
      GA_eventname: GaTrackingEventName.Interaction,
      action: GaTrackingEventAction.LOCATION_TOGGLER,
      label: `show ${this.selectedRegion}`,
    });
    event.stopPropagation();
  }

  closeOptions(event: Event) {
    this.toggleDropdown();
    event.stopPropagation();
  }

  toggleDropdown() {
    this.isOpen = !this.isOpen;
  }

  mouseLeave() {
    if (!this.mobileSidenavMenu) {
      this.isOpen = false;
    }
  }

  private rearrangeRegionsList(list: Region[]): Region[] {
    const defaultRegion = list.find((item) => item.id === DEFAULT_REGION_SPAIN);
    const defaultRegionIndex = list.indexOf(defaultRegion);
    if (defaultRegionIndex > -1) {
      list.splice(defaultRegionIndex, 1);
      list.unshift(defaultRegion);
    }
    return list;
  }
}
